import React from 'react';
import ReactDOM from 'react-dom/client';
import PartGallery from './PartGallery';
import SealPartGallery from './SealPartGallery';

const $root: HTMLElement | null = document.getElementById(
	'part-gallery',
);

if ($root) {
	const targetImageUrls = $root.dataset.imageUrls?.split(',').filter((url) => url.trim() !== '') || [];
	targetImageUrls.forEach((url, index) => {
		url = url.replace(/\\/g, '/');
		targetImageUrls[ index ] = url;
	});

	const targetAltText = $root.dataset.altText || '';

	const pdfDetails = $root.dataset.pdfDetails || {};

	ReactDOM.createRoot($root).render(
		<React.StrictMode>
			<PartGallery pdfDetails={pdfDetails} imageUrls={targetImageUrls} altText={targetAltText} />
		</React.StrictMode>
	);
} else {
	const $seal: HTMLElement | null = document.getElementById(
    	'seal-part-gallery',
    );

	if ($seal) {
		const targetImageUrls = $seal.dataset.imageUrls?.split(',').filter((url) => url.trim() !== '') || [];
        	targetImageUrls.forEach((url, index) => {
        		url = url.replace(/\\/g, '/');
        		targetImageUrls[ index ] = url;
        	});

        	const targetAltText = $seal.dataset.altText || '';
        	const pdfUrl = $seal.dataset.pdfUrl || '';

		ReactDOM.createRoot($seal).render(
			<React.StrictMode>
				<SealPartGallery pdfUrl={pdfUrl} imageUrls={targetImageUrls} altText={targetAltText} />
			</React.StrictMode>
		);
	}

}
